import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {Button, Col, Row} from "react-bootstrap";
import moment from "moment";
import {connect} from "react-redux";
import Modal from "../Modal";
import FormInput from "../forms/FormInput";
import FormLangInput from "../forms/FormLangInput";
import FormLangRichEditor from "../forms/FormLangRichEditor";
import FormAutocomplete from "../forms/FormAutocomplete";
import DateTimePicker from "../forms/DateTimePicker";
import FormSwitchery from "../forms/FormSwitchery";
import Loader from "../layout/Loader";
import _ from "lodash";
import { editServiceTypeR } from "../../actions/ServiceTypesActions";

class SubscriptionEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: undefined,
      title: undefined,
      name:  undefined,
      description: undefined,
      primary_rate:  undefined,
      secondary_rate:  undefined,

    };
  }

  componentDidMount = (prevProps) => {
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.show !== this.props.show && this.props.show === true){
      const { serviceTypesR} = this.props;
      // let serviceTypesR = [{id: "123", title: "serviceTypeTitel", type: "onboarding", rate1: "10%", rate2: "5%", }]
      const index = _.findIndex(serviceTypesR, serviceTypeR => serviceTypeR.id === this.props.serviceTypeId);
      if(index !== -1) {
        this.setState({
          id: serviceTypesR[index].id,
          title: serviceTypesR[index].title,
          name: serviceTypesR[index].name,
          description: serviceTypesR[index].description,
          primary_rate: serviceTypesR[index].primary_rate,
          secondary_rate: serviceTypesR[index].secondary_rate,
        })
      }
    }
  }



  editServiceType = () => {
    const { id, title, name, description, primary_rate, secondary_rate} = this.state;
    let data = {id: id,  title: title, name: name, description: description, primary_rate, secondary_rate};
    this.props.editServiceTypeR(this.props.serviceTypeId, data);
    this.props.close();
  }

  resetAndClose = () => {
    this.setState({name: undefined, description: undefined}, ()=>{
      this.props.close();
    })

  }


  render() {
    const { intl, show, close, appIntl} = this.props;
    const { title, name, primary_rate, secondary_rate} = this.state;
    const messages = intl.messages;
    let type_options = [messages.service_type_onboarding, messages.service_type_subscriptions, messages.service_type_additional_services, messages.service_type_product_sales];
console.log("title", title, "type")
    let editDisabled = "disabled";
    if(title !== undefined && name !== undefined && primary_rate !== undefined && secondary_rate !== undefined){
      editDisabled = "";
    }else{
      editDisabled = "disabled";
    }

    return (
      <Modal show={show} onHide={this.resetAndClose} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.edit_provision_type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div>
                <h4></h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm" >
                <FormLangInput
                  label={messages.provision_service_title}
                  name="title"
                  value={this.state.title}
                  onChange={(name, value) => this.setState({ title: value })}
                />
                {this.state.name !== undefined ?
                <FormAutocomplete
                  onChange={(name, value) => this.setState({ name: value })}
                  label={messages.provision_service_type}
                  name="name"
                  value={this.state.name}
                  options={type_options.map(option => {
                    return { label: option, value: option };
                  })}
                />
                  : <></>}

                {this.state.description !== undefined ?
                <FormLangRichEditor
                  name="description"
                  label={messages.provision_service_description_text}
                  value={this.state.description}
                  onChange={(name, value) => this.setState({ description: value })}
                /> : <></>}

                <FormInput
                  type="number"
                  label={messages.provision_service_primary_rate}
                  name="primary_rate"
                  onChange={(name, value) => this.setState({ primary_rate: value })}
                  value={this.state.primary_rate}
                  disabled=""
                />
                <FormInput
                  type="number"
                  label={messages.provision_service_secondary_rate}
                  name="secondary_rate"
                  onChange={(name, value) => this.setState({ secondary_rate: value })}
                  value={this.state.secondary_rate}
                  disabled=""
                />
                <Button onClick={()=>this.editServiceType()} disabled={editDisabled} bsStyle="primary"  className="pull-right" title="edit_service_type">
                  <span className="hidden-xs">{messages.save_provision_type}</span>
                </Button>
              </div>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>
    );
  }
}


const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    client: state.selectedClient.company,
    serviceTypesR: state.provisionServiceTypes.serviceTypesR,
    pending: state.provisionServiceTypes.pending,
  };
};

const mapDispatchToProps = dispatch => {

  return {
    editServiceTypeR: (id, data) => {
      dispatch(editServiceTypeR(id, data));
    },
  };

};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SubscriptionEdit)
  )
);

